import axios from 'axios'
import settings from '@/settings.js'

export default {
  namespaced: true,
  state: {
    list: [],
    meta: {},
    page: 1,
    item: null,
  },

  getters: {
    list: state => {
      return state.list;
    },
    meta: state => {
      return state.meta;
    },
    item: state => {
      return state.item;
    },
  },

  actions: {
    async getList({commit, state, rootState}, page) {
      if (page) {
        let list = await axios.get(`${settings.APP_SERVICE_URL}rest/driver-category?page=${page}`, {
          headers: {
            Authorization: `Bearer ${rootState.auth.token}`
          }
        });
        commit('SET_LIST', list.data)
      } else {
        let list = await axios.get(`${settings.APP_SERVICE_URL}rest/driver-category?page=${state.page}`, {
          headers: {
            Authorization: `Bearer ${rootState.auth.token}`
          }
        });
        commit('PUSH_LIST', list.data)
      }
    },
    async getCategory({commit, rootState}, id) {
      let item = await axios.get(`${settings.APP_SERVICE_URL}rest/driver-category/${id}`, {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      });
      commit('SET_ITEM', item.data)
    },
    /* eslint-disable no-empty-pattern */
    async save({rootState}, payload) {
      await axios.post(`${settings.APP_SERVICE_URL}rest/driver-category/`, payload, {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      });
    },
    async update({rootState}, payload) {
      await axios.patch(`${settings.APP_SERVICE_URL}rest/driver-category/${payload.id}`, payload, {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      });
    },
    async del({rootState}, payload) {
      await axios.delete(`${settings.APP_SERVICE_URL}rest/driver-category/${payload.id}`, {
        headers: {
          Authorization: `Bearer ${rootState.auth.token}`
        }
      });
    },
    clearCategories({ commit }) {
      commit('CLEAR_CATEGORIES');
    }
  },

  mutations: {
    PUSH_LIST(state, list) {
      state.page++;
      state.list.push(...list.data);
      state.meta  = list.meta;
    },
    SET_LIST(state, list) {
      state.list = list.data;
      state.meta  = list.meta;
    },
    SET_ITEM(state, item) {
      state.item  = item.driver_category;
    },
    CLEAR_CATEGORIES(state) {
      state.list = [];
      state.meta = {};
      state.item = null;
      state.page = 1;
    },
  },
};
